import { Combobox } from '../../atoms/Combobox.tsx'
import { TextInput } from '../../atoms/TextInput.tsx'
import type { ActionGate } from '../access.ts'

import './sampleHint.css'

/**
 * 시료의 자유 문자열 칸(종류 · 암종 · 암 병기) — **직접 입력 + 이전 값 제안**(2026-10-01 CTCells 회의
 * 「선택지 고정 대신 직접 입력 + 이전 입력값 자동완성 (암 외 연구용 시료도 존재)」).
 *
 * 시료 추가 폼(`SampleNewScreen`)과 **같은 원자(`Combobox`) · 같은 제안 출처(`sampleHints`)** 를 정정 폼 ·
 * 작업 추가 창의 「새 시료」 칸이 같이 쓰려고 뺐다.
 * 🔴 목록은 제안일 뿐이다 — 목록 밖 값도 그대로 나간다(서버는 열거 없는 자유 문자열).
 * 🔴 권한이 없으면 **비활성 + 사유**다. `Combobox` 에는 비활성 자리가 없어 같은 값을 비활성 `TextInput` 으로 보인다.
 */
export function SampleHintInput({
  value,
  onChange,
  options,
  label,
  toggleLabel,
  optionLabel,
  id,
  name,
  fieldGate,
}: {
  value: string
  onChange: (value: string) => void
  options: readonly string[]
  label: string
  toggleLabel: string
  /** 제안의 화면 표기(값 = 서버로 나가는 글자) */
  optionLabel?: ((value: string) => string) | undefined
  id?: string | undefined
  name?: string | undefined
  fieldGate?: ActionGate | undefined
}) {
  if (fieldGate?.disabled === true) {
    return (
      <span className="sample-hint">
        <TextInput
          disabled
          disabledReason={fieldGate.disabledReason}
          id={id}
          name={name}
          onChange={onChange}
          value={value}
          wide
        />
      </span>
    )
  }
  return (
    <span className="sample-hint">
      <Combobox
        id={id}
        label={label}
        name={name}
        onChange={onChange}
        optionLabel={optionLabel}
        options={options}
        toggleLabel={toggleLabel}
        value={value}
      />
    </span>
  )
}
